<template>
  <div
    ref="contentScroll"
    class="chat-frame-container"
    :style="{ 'margin-bottom': !getIsAIEnd() ? '20px' : '0' }"
  >
    <div
      :class="{
        'sidebar-loading': !isFullScreen(),
        'full-screen-loading': isFullScreen()
      }"
    >
      <div v-loading="loading" element-loading-spinner="el-icon-loading" />
    </div>
    <template v-for="(item, index) in getChatMessageList">
      <div v-if="custom && item.isNewChat" :key="index" class="clear-history">
        <span @click="$emit('clearHistory')">清除历史对话</span>
      </div>
      <el-divider
        v-if="isFullScreen() && item.type === 'G'"
        :key="index"
        content-position="center"
        class="divider-full"
        @mousedown="allowTextSelection"
      >
        {{ item.text }}
      </el-divider>
      <el-divider
        v-if="!isFullScreen() && item.type === 'G'"
        :key="index"
        content-position="center"
        class="divider"
        @mousedown="allowTextSelection"
      >
        {{ item.text }}
      </el-divider>
      <ChatWelcome
        v-if="item.type === 'welcome'"
        :key="index"
        class="chat-welcome"
        @mousedown="allowTextSelection"
      />
      <!--  :search-result="item.process?item.process.processData.searchResult:[]" 测试的时候删除这个 -->
      <ChatMessageAi
        v-if="item.type === 'ai'"
        :key="index"
        :data="item"
        :text="item.text"
        :message-id="item.conversation_id || item.id"
        :has-new-list="item.hasNewList ? item.hasNewList : false"
        :thinking-txt="item.thinkingTxt"
        :news-name="item.news ? item.news.newsName : ''"
        :news-list="item.news ? item.news.newsList : []"
        :type="item.type"
        :img-error="item.imgError"
        :is-skip="item.tmpInfo ? item.tmpInfo.isMust == 2 : false"
        :tmp-is-ok="item.tmpIsOk"
        :is-collect="item.isCollect"
        :is-history="item.isHistory"
        :is-like="item.isLike"
        :is-no-like="item.isNoLike"
        :source="item.source"
        :video-load-text="item.videoLoadText"
        :index="index"
        :is-send-selected-topic="item.isSendSelectedTopic"
        :is-hotspot="item.isHotspot"
        @createTopic="createTopic"
        @openRevision="openRevision"
        @resetAnswer="resetAnswer(index)"
        @collectSearch="collectSearch"
      />
      <ChatMessageUser
        v-if="item.type === 'user' && !item.hide"
        :key="index"
        :index="index"
        :text="item.text"
        :message-type="item.messageType"
        :file-extension="item.fileExtension"
        :file-name="item.fileName"
        :file-size="item.fileSize"
        :file-image-url="item.fileImageUrl"
        :file-url="item.fileUrl"
        :format="item.format"
        :is-sensitive="item.isSensitive"
        :is-sensitive-reply="item.isSensitiveReply"
        @editSensitive="editSensitive"
        @addTemp="$emit('addTemp', item.text)"
      />
    </template>

    <div v-if="isBacktop" class="backtop" @click="backtop">
      <template v-if="!backTopLoading">
        <img
          class="img-icon"
          src="@/assets/image/aigc/go-bottom.png"
          alt=""
          style="width: 17px; height: 17px"
        />
        <img
          class="img-icon-select"
          src="@/assets/image/aigc/go-bottom-select.png"
          alt=""
          style="width: 17px; height: 17px"
        />
      </template>
      <div v-else class="loading-spinner" />
    </div>
    <div
      v-if="
        !getIsAIEnd() &&
        (!isFullScreen() ||
          getIsShowDouyinBZhangGuide ||
          getIsShowImageGeneration)
      "
      style="height: 64px; width: 100%"
    />
  </div>
</template>
<script>
import ChatWelcome from './ChatWelcome.vue'
import ChatMessageUser from './ChatMessageUser.vue'
import ChatMessageAi from './ChatMessageAI.vue'
export default {
  components: {
    ChatWelcome,
    ChatMessageUser,
    ChatMessageAi
  },
  inject: [
    'isFullScreen',
    'getChatMessageList',
    'getHistory',
    'getIsAIEnd',
    'setIsAIEnd',
    'closeWS',
    'setDisabledInput',
    'removeChatMessageItem',
    'setIndexChatCustomKeyMessage',
    'setModelType',
    'getModelList',
    'getTypeAIList',
    'getPageIndex'
  ],
  props: {
    custom: {
      type: Boolean,
      default: false
    },
    wordExtractIndex: {
      type: Number,
      default: 0
    },
    // 会话id
    conversationId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      loading: false,
      isToBottom: true,
      isBacktop: false,
      backTopLoading: false
    }
  },
  computed: {
    getIsShowImageGeneration() {
      return !!this.getTypeAIList.find(
        item => item.checked && item.assistantType === 'ImageGeneration'
      )
    },
    getIsShowDouyinBZhangGuide() {
      return !!this.getTypeAIList.find(
        item => item.checked && item.assistantType === 'VideoExtract'
      )
    }
  },
  updated() {
    this.scrollToBottom()
  },
  mounted() {
    // 监听页面缩放
    this.$nextTick(() => {
      window.addEventListener('resize', this.scrollToBottom())
    })
    this.$refs.contentScroll.addEventListener('scroll', e =>
      this.wctchScroll(e)
    )
  },
  destroyed() {
    this.$refs.contentScroll?.removeEventListener('scroll', e =>
      this.wctchScroll(e)
    )
    window.removeEventListener('resize', this.scrollToBottom(false))
  },
  methods: {
    allowTextSelection(event) {
      // 取消事件冒泡，确保文本选择事件能够正常触发
      event.stopPropagation()
    },
    openRevision(text) {
      this.$emit('openRevision', text)
    },
    resetAnswer(index) {
      this.$emit('resetAnswer', index)
    },
    createTopic(text) {
      this.$emit('createTopic', text)
    },
    async backtop() {
      if (this.backTopLoading) return
      if (this.getPageIndex() !== 1) {
        this.backTopLoading = true
        await this.getHistory(
          false,
          this.getTypeAIList[this.wordExtractIndex],
          this.conversationId
        )
        this.backTopLoading = false
      }
      this.$nextTick(() => {
        const srcollE = this.$refs.contentScroll
        const params = {
          top: srcollE.scrollHeight,
          behavior: 'smooth'
        }
        srcollE.scrollTo(params)
      })
    },
    collectSearch() {
      this.$emit('collectSearch')
    },
    wctchScroll(e) {
      // 判断是否用户主动滚动
      const distanceToBottom =
        this.$refs.contentScroll.scrollHeight -
        this.$refs.contentScroll.scrollTop -
        this.$refs.contentScroll.clientHeight
      this.isToBottom = distanceToBottom < 10
      // 监听滚动条距离底部
      if (distanceToBottom < 500) {
        this.isBacktop = false
      } else {
        this.isBacktop = true
      }
      // 监听滚动条到顶部
      if (this.$refs.contentScroll.scrollTop === 0) {
        if (this.loadin) return
        this.loading = true

        if (this.custom) {
          this.getHistory(
            true,
            this.getTypeAIList[this.wordExtractIndex],
            this.conversationId
          ).then(res => {
            this.$refs.contentScroll.scrollTo({
              top: res ? 10 : 0,
              behavior: 'smooth'
            })
            this.loading = false
          })
        } else {
          this.getHistory(true).then(res => {
            this.$refs.contentScroll.scrollTo({
              top: res ? 10 : 0,
              behavior: 'smooth'
            })
            this.loading = false
          })
        }
      }
    },
    editSensitive(item) {
      this.$emit('setInput', item)
    },
    scrollToBottom(isNext = true) {
      if (!isNext || !this.isToBottom) return
      this.$nextTick(() => {
        const srcollE = this.$refs.contentScroll
        const params = {
          top: srcollE.scrollHeight,
          behavior: 'auto'
        }
        srcollE.scrollTo(params)
      })
    },
    setInput(val) {
      this.$emit('setInput', val)
    },
    activeChatTopic(data) {
      this.$emit('activeTopicItem', data)
    }
  }
}
</script>
<style lang="scss" scoped>
.chat-frame-container {
  background-color: #fff;
  box-sizing: border-box;
  overflow-x: hidden;
  // position: relative;
  .backtop {
    position: sticky;
    width: 30px;
    height: 30px;
    float: right;
    border-radius: 50%;
    bottom: 2%;
    right: 0px;
    z-index: 1000;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    background: #e0e4e6;
    box-shadow: 0px 0px 6px 0px rgba(21, 36, 67, 0.1);
    transition: all 0.3s;
    .img-icon {
      width: 24px;
      height: 24px;
    }
    .img-icon-select {
      display: none;
      width: 24px;
      height: 24px;
    }
    &:hover {
      background: #1778ff;
      .img-icon {
        display: none;
      }
      .img-icon-select {
        display: block;
      }
    }
    .loading-spinner {
      width: 17px;
      height: 17px;
      border: 2px solid #e0e4e6;
      border-top: 2px solid #1778ff;
      border-radius: 50%;
      animation: spin 1s linear infinite;
    }
  }
  .sidebar-loading {
    position: fixed;
    top: 95px;
    right: 12%;
    height: 10px;
  }
  .full-screen-loading {
    position: fixed;
    top: 95px;
    right: 55%;
    height: 10px;
  }
  .chat-welcome {
    margin: 32px;
  }
}
::v-deep {
  .public-divider {
    .el-divider__text {
      background: #fafafa;
      color: #c7cace;
    }
  }

  .divider {
    @extend .public-divider;
    margin: 24px 16px 24px 14px;
  }
  .divider-full {
    @extend .public-divider;
    margin: 24px;
  }

  .clear-history {
    text-align: center;

    span {
      font-size: 14px;
      color: #3a7fff;
      cursor: pointer;
    }
  }
}
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
